import { useMediaQuery, useTheme } from "@mui/material";

/**
 * Shared breakpoint flags so every part of a page switches layout at the same widths
 * instead of each component inventing its own `sx` breakpoints.
 *
 * Values come from baseTheme: xs 0 / sm 480 / md 768 / lg 1024 / xl 1440.
 *
 * - isPhone   (<480)      one column, cards instead of tables, no horizontal scroll
 * - isCompact (<768)      phone + small tablet portrait; data grids become card lists,
 *                         chart stacks become tab strips
 * - isTablet  (768-1023)  grids keep working but with a folded column set
 * - isDesktop (>=1024)    full column sets
 * - isWide    (>=1440)    wide enough for the dashboard's analytics side rail
 */
export const useResponsive = () => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const isCompact = useMediaQuery(theme.breakpoints.down("md"));
  const isTablet = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const isWide = useMediaQuery(theme.breakpoints.up("xl"));

  return { isPhone, isCompact, isTablet, isDesktop, isWide };
};

export default useResponsive;
